import { Pipe, PipeTransform } from '@angular/core';
import { INFINITE_SCROLL_ITEMS_PER_PAGE } from '@shared/constants/infinite-scroll.constants';

@Pipe({
  name: 'lazyLoad',
  standalone: true,
  pure: true,
})
export class LazyLoadPipe implements PipeTransform {
  transform<T>(
    items: T[],
    itemsPerPage = INFINITE_SCROLL_ITEMS_PER_PAGE,
    currentPage = 1,
  ): T[] {
    if (!items || items.length === 0) {
      return [];
    }

    const endIndex = itemsPerPage * currentPage;
    return items.slice(0, endIndex);
  }
}
